import { Tooltip, Chip } from "@material-ui/core";
import { format } from 'date-fns';


// {{startTime }} to {{ endTime }} from {{ date }} -> tooltip  


const normalizeDate = (date) => {
    if (date == null)
        return date;
    let temp_date = new Date(date.getTime())
    temp_date = new Date(temp_date.setMinutes(temp_date.getMinutes() + temp_date.getTimezoneOffset()))
    return temp_date
}


export default function SlotCard({ data, onEdit, onDelete }) {
    let recurringMessage = '';
    if (data.repeatFrequency === 'day') {
        recurringMessage += `Repeats every ${data.repeatEvery} days`;
    } else if (data.repeatFrequency === 'week') {
        recurringMessage += `Repeats every ${data.repeatEvery} weeks on ${data?.repeatOn.join(',')}`
    } else if (data.repeatFrequency === 'month') {
        // console.log(data.start,typeof(data.start))
        const start = typeof(data?.start)==='string'?new Date(data?.start):data?.start
        recurringMessage += `Repeats every ${data.repeatEvery} months on day ${start.getDate()}`
    } else if (data.repeatFrequency === 'year') {
        recurringMessage += `Repeats every ${data.repeatEvery} years on <date>`;
    }
    if (data.endingType === 'ends-on') {
        recurringMessage += ' until ' + format(new Date(data?.end?.toString()) || new Date(), 'P');
    } else if (data.endingType === 'ends-after') {
        recurringMessage += ` after ${data.endsAfter} occourences`;
    }

    try {
        const startTime = format(normalizeDate(new Date(data?.startTime?.toString())) || new Date(), 'hh:mm a')
        const endTime = format(normalizeDate(new Date(data?.endTime?.toString())) || new Date(), 'hh:mm a')
        const startDate = format(new Date(data?.start?.toString()) || new Date(), 'P')
        return (
            <Tooltip title={recurringMessage}>
                <Chip onClick={onEdit} onDelete={onDelete} label={`${startTime} to ${endTime} from ${startDate}`} />
            </Tooltip>
        )
    } catch (e) {
        return null;
    }
}